import React, { useCallback, useEffect, useState } from 'react';
import { isNull } from 'lodash';
import cx from 'classnames';
import Select from '../../input/Select';
import './TableFilterSelect.scss';

const TableFilterSelect = (props) => {
  const { className, list, option = null, onFilter, setSelectedKeys, confirm, clearFilters } = props;

  /**
   *  함수형 컴포넌트에서 사용될 state 초기화
   */
  const [value, setValue] = useState(null);

  /**
   *  `option` props 가 변경이 있을 때, 실행됨.
   *   value 의 option 값으로 업데이트 함
   */
  useEffect(() => {
    setValue(option);
  }, [option, value]);

  /**
   *  select onchange event 가 발생을 할 경우
   */
  const onChange = useCallback(
    (value) => {
      confirm();

      onFilter && onFilter(value);
      setSelectedKeys && setSelectedKeys([value]);

      setValue(value);

      if (clearFilters && isNull(value)) {
        clearFilters();
      }
    },
    [clearFilters, confirm, onFilter, setSelectedKeys],
  );

  if (!list) return null;

  return (
    <div className={cx('table-filter-select-wrap', className)}>
      <Select list={list} onChange={onChange} defaultValue={value} value={value} isTable={true} size="large" />
    </div>
  );
};

export default TableFilterSelect;
